import React from "react";
import { InfiniteSlider } from "@/components/ui/infinite-slider";
import { Check, X } from "lucide-react";

interface ComparisonRow {
  feature: string;
  gimmefy: string;
  chatgpt: string;
  jasper: string;
}

interface ScrollingComparisonCardsProps {
  rows: ComparisonRow[];
}

const ScrollingComparisonCards: React.FC<ScrollingComparisonCardsProps> = ({ rows }) => {
  // Define color themes for card variations
  const colorThemes = [
    {
      cardBg: "bg-blue-50/50",
      cardBorder: "border-blue-200/50",
      gimmefyBg: "bg-blue-100/70",
      gimmefyBorder: "border-blue-300/60",
      gimmefyAccent: "bg-blue-500",
      gimmefyText: "text-blue-700"
    },
    {
      cardBg: "bg-emerald-50/50",
      cardBorder: "border-emerald-200/50",
      gimmefyBg: "bg-emerald-100/70",
      gimmefyBorder: "border-emerald-300/60",
      gimmefyAccent: "bg-emerald-500",
      gimmefyText: "text-emerald-700"
    },
    {
      cardBg: "bg-orange-50/50",
      cardBorder: "border-orange-200/50",
      gimmefyBg: "bg-orange-100/70",
      gimmefyBorder: "border-orange-300/60",
      gimmefyAccent: "bg-orange-500",
      gimmefyText: "text-orange-700"
    },
    {
      cardBg: "bg-purple-50/50",
      cardBorder: "border-purple-200/50",
      gimmefyBg: "bg-purple-100/70",
      gimmefyBorder: "border-purple-300/60",
      gimmefyAccent: "bg-purple-500",
      gimmefyText: "text-purple-700"
    }
  ];

  return (
    <div className="w-full">
      <InfiniteSlider
        duration={60}
        durationOnHover={120}
        gap={16}
        className="py-4"
      >
        {rows.map((row, index) => {
          const theme = colorThemes[index % colorThemes.length];
          return (
            <div
              key={index}
              className={`w-80 ${theme.cardBg} border ${theme.cardBorder} rounded-xl p-6 shadow-sm flex-shrink-0`}
            >
              {/* Feature Title */}
              <h3 className="text-base font-semibold text-foreground mb-4 text-center">
                {row.feature}
              </h3>
              
              {/* gimmefy - Highlighted */}
              <div className={`${theme.gimmefyBg} rounded-lg p-4 mb-3 border ${theme.gimmefyBorder}`}>
                <div className="flex items-start gap-3">
                  <div className={`${theme.gimmefyAccent} rounded-full p-1 flex-shrink-0 mt-0.5`}>
                    <Check className="h-3 w-3 text-white" />
                  </div>
                  <div>
                    <div className={`text-sm font-medium ${theme.gimmefyText} mb-1`}>gimmefy</div>
                    <div className="text-sm text-foreground leading-relaxed">{row.gimmefy}</div>
                  </div>
                </div>
              </div>
              
              {/* ChatGPT */}
              <div className="flex items-start gap-3 mb-3">
                <div className="bg-muted rounded-full p-1 flex-shrink-0 mt-0.5">
                  <X className="h-3 w-3 text-muted-foreground" />
                </div>
                <div>
                  <div className="text-sm font-medium text-muted-foreground mb-1">ChatGPT</div>
                  <div className="text-sm text-muted-foreground leading-relaxed">{row.chatgpt}</div>
                </div>
              </div>
              
              {/* Jasper */}
              <div className="flex items-start gap-3">
                <div className="bg-muted rounded-full p-1 flex-shrink-0 mt-0.5">
                  <X className="h-3 w-3 text-muted-foreground" />
                </div>
                <div>
                  <div className="text-sm font-medium text-muted-foreground mb-1">Jasper</div>
                  <div className="text-sm text-muted-foreground leading-relaxed">{row.jasper}</div>
                </div>
              </div>
            </div>
          );
        })}
      </InfiniteSlider>
    </div>
  );
};

export default ScrollingComparisonCards;